'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    caption2StrongClassNames: function() {
        return caption2StrongClassNames;
    },
    useCaption2StrongStyles: function() {
        return useCaption2StrongStyles;
    }
});
const _react = require("@griffel/react");
const caption2StrongClassNames = {
    root: 'fui-Caption2Strong'
};
const useCaption2StrongStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f13mqy1h",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fcpl73t"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f13mqy1h{font-size:var(--fontSizeBase100);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fcpl73t{line-height:var(--lineHeightBase100);}"
    ]
});
